import App from "@/App.vue";

export default [
  {
    path: "/corretoras",
    name: "brokers",
    component: App,
    redirect: { name: "list brokers" },
    children: [
      {
        path: "",
        name: "list brokers",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/ListBrokers.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Corretoras",
              disabled: false,
              link: false,
              to: { name: "brokers" }
            }
          ],
          displayName: "Lista Corretoras - Lockton",
          requiresAuth: true,
          permissionRoute: "visualizar_seguradora"
        }
      },
      {
        path: "/nova-corretora",
        name: "new broker",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditBroker.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Nova Corretora",
              disabled: false,
              link: true,
              to: { name: "brokers" }
            }
          ],
          displayName: "Nova Corretora",
          requiresAuth: true,
          permissionRoute: "criar_seguradora"
        }
      },
      {
        path: "/editar-corretora/:id",
        name: "edit broker",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditBroker.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Editar Corretora",
              disabled: false,
              link: true,
              to: { name: "brokers" }
            }
          ],
          displayName: "Editar Corretora",
          requiresAuth: true,
          permissionRoute: "editar_seguradora"
        }
      },
    ]
  }
];
